<div class="p-8 bg-white dark:bg-gray-800 rounded-xl shadow-sm mx-auto mt-10">
  <h2 class="text-2xl font-semibold mb-6 text-gray-800 dark:text-white flex items-center gap-2">
    <!-- <span class="material-symbols-outlined text-primary">sync</span> -->
    Sync Users from UMS
  </h2>

  <button
    *ngIf="showSyncButton"
    (click)="syncUsers()"
    [disabled]="loading"
    class="flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white font-medium rounded-lg hover:bg-primary/90 transition-all cursor-pointer disabled:opacity-50"
  >
    <span class="material-symbols-outlined animate-spin" *ngIf="loading">autorenew</span>
    <span *ngIf="!loading">Sync Now</span>
    <span *ngIf="loading">Syncing...</span>
  </button>

  <div
    *ngIf="!showSyncButton"
    class="mt-6 p-4 bg-yellow-50 text-yellow-700 border border-yellow-300 rounded-lg shadow-sm transition-all"
  >
    <p class="font-semibold">⚠️ You are not authorized to sync users.</p>
  </div>

  <!-- Success Response -->
  <div
    *ngIf="result"
    class="mt-6 p-4 bg-green-50 text-green-700 border border-green-300 rounded-lg shadow-sm transition-all"
  >
    <p class="font-semibold mb-2">Sync Successful!</p>
    <pre class="text-sm whitespace-pre-wrap">{{ result | json }}</pre>
  </div>

  <!-- Error Message -->
  <div
    *ngIf="errorMessage"
    class="mt-6 p-4 bg-red-50 text-red-700 border border-red-300 rounded-lg shadow-sm transition-all"
  >
    <p class="font-semibold mb-1">Sync Failed</p>
    <p class="text-sm">{{ errorMessage }}</p>
  </div>
</div>
